import React from "react";

export default function PageHeader({ eyebrow, title, description, right }) {
  return (
    <div className="flex items-end justify-between gap-6 mb-8 animate-fade-up">
      <div>
        {eyebrow && <div className="label-caps mb-2">{eyebrow}</div>}
        <h1 className="font-heading text-4xl sm:text-5xl tracking-tight text-foreground leading-tight">
          {title}
        </h1>
        {description && (
          <p className="mt-3 text-muted-foreground max-w-2xl text-base">{description}</p>
        )}
      </div>
      {right && <div className="flex items-center gap-2">{right}</div>}
    </div>
  );
}
